module.exports = __webpack_public_path__ + "static/media/7-iveco-mercedes.86f10f89.jpg";